import React, { useState, useEffect, useContext } from "react";
import {
  getProducts,
  getSuppliers,
  getTax,
  getUnits,
  getManufacturers,
  getWarehouseProduct,
  createBulkPurchase,
  getPurchase,
  getPurchaseorderDetail,
  getInvoiceNumber,
  createAssets,
  updatePurchaseCredit,
  SupplierPurchaseDetails,
  postGeneralData,
  getRawMaterials,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import ProductForm from "../Product/Form";
import { WarehouseContext } from "../../../Utility/UserContext";
import {
  generateRandomCode,
  getFormattedCurrentDate2,
  handleCreateAssets,
  onReqCreatePayment,
  shop_id,
  validateDates,
} from "../../../Utility/function";
import "./dropdown.css";
import {
  CommonCardUi,
  InputField,
  InputField1,
  NewCommonCardUi,
  SelectOption,
} from "../../Common/CommonCard";
import SupplierForm from "../Suppliers/form";
import { useLocation, useNavigate } from "react-router-dom";
import PaymentModal from "../../Common/PaymentModal";
import CashModal from "../SalesWindow/modal/CashModal";
import CashCardModal from "../SalesWindow/modal/CashCardModal";
import CardModal from "./modal/CardModal";

const EditPurchase = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const [taxes, setTax] = useState([]);
  const [Units, setUnits] = useState([]);
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [filteredSuppliers, setFilteredSuppliers] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [SupplierId, setSupplierId] = useState(0);
  const [Manufacturers, setManufacturers] = useState([]);
  const { selectedWarehouse } = useContext(WarehouseContext);
  const [unqui, setunqui] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [supplierdata, setsupplierData] = useState();
  const [productdata, setproductData] = useState();
  const { showLoader, hideLoader, shopItem, UserItem } = useContext(WarehouseContext);
  const [AuthUser, setAuthUser] = useState(UserItem);
  const [discount, setDiscount] = useState(0);
  const [vat, setVat] = useState(0);
  const [freightCharges, setFreightCharges] = useState(0);
  const [otherCharges, setOtherCharges] = useState(0);
  const [previousDue, setPreviousDue] = useState(0);
  const [roundoff, setRoundOff] = useState(0);
  const [PurchaseOrder, setPurchaseOrder] = useState([]);
  const [PO, setPO] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [isUpdate, setIsUpdate] = useState("1");
  const [paidamount, setPaidAmount] = useState();
  const [SupplierBalance, setSupplierBalance] = useState();
  const [rawMaterials, setRawMaterials] = useState([]);
  const [filteredRawMaterials, setFilteredRawMaterials] = useState([]);
  const [rawMaterialData, setRawMaterialData] = useState();
  const [inputValue, setInputValue] = useState("");
  const [SupplierValue, setSupplierValue] = useState("");
  const [rows, setRows] = useState([]);

  const handleClose = () => {
    setIsOpen(false);
    setFile(null);
  };

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  useEffect(() => {
    fetchSuppliers();
    fetchManufacturers();
    fetchTax();
    fetchUnit();
    fetchRawMaterials();
  }, []);

  useEffect(() => {
    if (state) {
      GetPurchaseData(state);
      setformData({
        ...formData,
        warehouse_id: selectedWarehouse?.id,
        invoice_no: state.invoice_no || '',
        invoice_date: state.date,
        purchase_unit: state.purchase_unit,
        lpo_no: state.lpo_no,
        tax_type: taxes.find((t) => Number(t.value || 0) === Number(state.vat || 0))?.id || '',
        remark: '',
        supplier_id: state?.supplier_id || '',
      });
      setFreightCharges(state.freight_charges);
      setDiscount(state.discount);
      setOtherCharges(state.other_charges);
      setPaidAmount(Number(state.total) - Number(state.remaining));
      setVat(state.vat);
      setSupplierId(state.supplier_id);
      fetchSupplierData(state.supplier_id);
      setRoundOff(state.round_off);
    }
  }, [taxes]);

  const fetchUnit = async () => {
    try {
      const response = await getUnits();
      if (response.data && response.data.data) {
        setUnits(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching units data:", error);
    }
  };

  const fetchTax = async () => {
    try {
      const response = await getTax();
      if (response.data && response.data.data) {
        setTax(response.data.data);
      } else {
        toast.error("No Tax found.");
      }
    } catch (error) {
      console.error("Error fetching Tax:", error);
      toast.error("Error fetching Tax");
    }
  };

  const fetchSuppliers = async () => {
    try {
      const response = await getSuppliers();
      if (response.data && response.data.data) {
        setSupplier(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await getManufacturers(1);
      if (response.data && response.data.data) {
        setManufacturers(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching manufacturers data:", error);
    }
  };

  const fetchRawMaterials = async () => {
    try {
      const response = await getRawMaterials();
      if (response.data && response.data.data) {
        setRawMaterials(response.data.data);
        setFilteredRawMaterials(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching raw materials:", error);
    }
  };

  const fetchSupplierData = async (id) => {
    try {
      const res = await SupplierPurchaseDetails(id, shop_id);
      const totalRemaining = res.data.data.reduce((sum, item) => sum + parseFloat(item.remaining || 0), 0);
      setSupplierBalance(totalRemaining);
      setPreviousDue(totalRemaining);
    } catch (error) {
      console.error("Error fetching supplier details:", error);
    }
  };

  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, rowIndex) => rowIndex !== index);
    setRows(updatedRows);
  };

  const handleRawMaterialChange = (value) => {
    setInputValue(value);

    if (value === "") {
      setFilteredRawMaterials(rawMaterials.filter(item => item.status != 2));
    } else {
      const filtered = rawMaterials.filter(material =>
        material.status != 2 && material.title?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredRawMaterials(filtered);
    }
  };

  const [formData, setformData] = useState({
    warehouse_id: selectedWarehouse?.id,
    invoice_no: "",
    invoice_date: "",
    purchase_unit: "",
    tax_type: "",
    remark: "",
    supplier_id: "",
    purchase_price: "",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
    qty: "",
    total_amount: "",
    manufactured_date: "",
    expiry_date: "",
    lpo_no: "",
  });

  const handleSupplierChange = (value) => {
    setSupplierValue(value);

    if (value === "") {
      setFilteredSuppliers(supplier.filter(item => item.status != 2));
    } else {
      const filtered = supplier.filter(supplier =>
        supplier.status != 2 && supplier.full_name?.toLowerCase().includes(value?.toLowerCase())
      );
      setFilteredSuppliers(filtered);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setformData({ ...formData, [name]: value });

    if (name === "raw_mat_id") {
      setInputValue(e.target?.raw_name);
      setFilteredRawMaterials([]);
    }

    if (name === "tax_type") {
      setVat(taxes.find((item) => item.id == value)?.value || 0);
    }

    if (name === "supplier_id") {
      setSupplierValue(e.target?.pro_name);
      setFilteredSuppliers([]);
      fetchSupplierData(value);
    }

    if (name === "purchase_price") {
      setformData({
        ...formData,
        ["total_amount"]: formData.qty * value,
        [name]: value,
      });
    } else if (name === "qty") {
      setformData({
        ...formData,
        ["total_amount"]: (formData.purchase_price || 0) * value,
        [name]: value,
      });
    }
  };

  const handlecancel = () => {
    setformData({
      invoice_no: "",
      invoice_date: "",
      purchase_unit: "",
      tax_type: "",
      remark: "",
      raw_mat_id: "",
      supplier_id: "",
      purchase_price: "",
      qty: "",
      total_amount: "",
      manufactured_date: "",
      expiry_date: "",
      lpo_no: "",
    });
    setInputValue("");
    setRawMaterialData();
    setsupplierData("");
    setSupplierValue("");
  };

  const fields = (
    <>
      <div className="row">
        <div className="col-lg-4 col-12">
          <div className="card p-3" style={{ minHeight: "105px" }}>
            {InputField(
              "Invoice Date",
              "invoice_date",
              "date",
              formData.invoice_date || new Date().toISOString().split("T")[0],
              handleChange,
              "Enter Invoice date",
              12
            )}
            {SelectOption(
              "Purchase Type",
              "purchase_unit",
              formData.purchase_unit,
              handleChange,
              "Select Purchase",
              [
                { title: "Cash", id: "1" },
                { title: "Credit", id: "2" },
              ]
            )}
            {SelectOption(
              "Tax Type",
              "tax_type",
              formData.tax_type,
              handleChange,
              "Select Tax",
              taxes
            )}
            {InputField(
              "L.P.O NO.",
              "lpo_no",
              "text",
              formData.lpo_no,
              handleChange,
              "Enter L.P.O NO",
              12
            )}
          </div>
        </div>
        <div className="col-lg-4 col-12">
          <div className="card mb-0 p-3">
            <div className={`form-group mb-2 d-flex align-items-center`}>
              <label className="col-4 text-verysmall">Supplier</label>
              <div className="searchable-dd w-100 d-flex" style={{ maxHeight: "1rem" }}>
                <input
                  type="text"
                  className="text-small w-100"
                  value={SupplierValue}
                  height={"1.5rem"}
                  onChange={(e) => handleSupplierChange(e.target.value)}
                  placeholder="Search Supplier"
                  required
                  disabled={true}
                />
                {SupplierValue && filteredSuppliers.length > 0 && (
                  <div className="custom-dropdown">
                    {filteredSuppliers.map((pro) => (
                      <div
                        key={pro.supplier_id}
                        className="dropdown-item"
                        onClick={() => {
                          handleChange({
                            target: {
                              name: "supplier_id",
                              value: pro.supplier_id,
                              pro_name: pro.full_name,
                            },
                          });
                          setsupplierData(
                            supplier.find((item) => item.supplier_id == pro.supplier_id)
                          );
                          setSupplierId(pro.supplier_id);
                        }}
                      >
                        {pro.full_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            {InputField(
              "Contact no",
              "ref_2",
              "text",
              supplierdata?.phone || "",
              () => { },
              "",
              12,
              null,
              undefined,
              undefined,
              true
            )}

            <div className="d-flex mt-2 column-gap-4">
              {/* <span className="text-small font-weight-2">Balance</span> */}
              <span className="text-small font-weight-2">outstanding/opening Balance</span>
              <span className="text-small font-weight-2">{SupplierBalance || "0.00"}</span>
            </div>
          </div>
        </div>
        {/* <div className="col-lg-4 col-12">
          <div className="row-gap-2 d-flex flex-wrap mt-1">
            <div
              className="mx-1 d-flex align-items-center justify-content-center cursor-pointer"
              onClick={() => setPO(true)}
              style={{ width: "100%", height: "55px", background: "green" }}
            >
              <h6 className="text-center text-white m-0">Purchase Order</h6>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );

  const getTotal = () => {
    var sub_total = rows.reduce(
      (acc, item) => acc + (parseFloat(item.total_amount) || 0),
      0
    );
    var dis = (sub_total * (discount ? parseFloat(discount) : 0)) / 100;
    var varcount = (sub_total * (vat ? parseFloat(vat) : 0)) / 100;
    var freight = freightCharges ? parseFloat(freightCharges) : 0;
    var other = otherCharges ? parseFloat(otherCharges) : 0;

    var total = sub_total + varcount + freight + other - dis;
    var roundOff = Math.round(total) - total;
    var grandTotal = total + roundOff;
    var balance = previousDue ? parseFloat(previousDue) : 0;

    if (formData.purchase_unit == "2") {
      balance = (previousDue ? parseFloat(previousDue) : 0) + grandTotal;
    }

    return { sub_total, total, roundOff, grandTotal, balance };
  };

  const GetPurchaseData = async (purchase) => {
    try {
      const res = await getPurchaseorderDetail(purchase.po);
      const dataList = res.data.data;

      if (dataList.length) {
        setSupplierId(purchase?.supplier_id);
        setunqui(purchase?.po);
        setSupplierValue(purchase?.supplier_name);
        setsupplierData({
          supplier_id: purchase.supplier_id,
          address1: purchase.supplier_address,
          phone: purchase.supplier_phone,
        });

        const updatedRows = dataList.map((item, index) => ({
          id: index + 1,
          raw_mat_id: item.raw_mat_id,
          supplier_id: purchase.supplier_id,
          product_name: item.rawmaterial_name || item.raw_material_name,
          qty: item.qty,
          warehouse_id: selectedWarehouse?.id,
          item_code: item.product_code,
          purchase_price: parseFloat(item.unit_pricen || 0),
          total_amount: parseFloat(item?.unit_pricen || 0) * parseFloat(item?.qty || 0),
          manufactured_date: item.manufactured_date,
          expiry_date: item.expiry_date,
          purchase_unit: item.purchase_unit,
          tax_type: item.tax_type,
          shop_id: shopItem?.shop_id || "0",
        }));

        setRows(updatedRows);
      }

      setPO(false);
    } catch (error) {
      console.error("Error fetching purchase details:", error);
      toast.error("Failed to load purchase details");
    }
  };

  const handleUpdateProduct = (index, value, name) => {
    const updatedRows = [...rows];
    updatedRows[index] = {
      ...updatedRows[index],
      [name]: value,
    };

    if (name === "purchase_price") {
      updatedRows[index] = {
        ...updatedRows[index],
        ["total_amount"]: updatedRows[index].qty * value,
        [name]: value,
      };
    } else if (name === "qty") {
      updatedRows[index] = {
        ...updatedRows[index],
        ["total_amount"]: (updatedRows[index].purchase_price || 0) * value,
        [name]: value,
      };
    }

    setRows(updatedRows);
  };

  const [showPayModal, setShowPayModal] = useState(false);
  const [purchaseUnit, setPurchaseUnit] = useState("1");
  const [input, setInput] = useState("");
  const [cashShow, setCashShow] = useState(false);
  const [cardShow, setCardShow] = useState(false);
  const [cashCardShow, setCashCardShow] = useState(false);
  const [showSupplierModal, setshowSupplierModal] = useState(false);

  const handlePaymentType = (type) => {
    setPurchaseUnit(type);
    if (type == "1") {
      setCashShow(true);
      setInput("");
    } else if (type == "2") {
      handleSubmit(type);
    } else if (type == "5") {
      setCashCardShow(true);
      setInput("");
    } else if (type == "4") {
      setCardShow(true);
      setInput("");
    }
    setShowPayModal(false);
  };

  const handleClick = (value) => {
    setInput((prev) => {
      if (value === ".") {
        if (prev.includes(".") || prev === "") return prev;
      }
      return prev + value;
    });
  };

  const handleBackspace = () => {
    setInput((prev) => prev.slice(0, -1));
  };

  const getAmountDue = () => {
    const total = getTotal().total || 0;
    const paid = parseFloat(paidamount) > 0 ? parseFloat(paidamount) : 0;
    return (total - paid).toFixed(3);
  };

  const getReturnValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) >= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const getReminingValue = () => {
    const amountDue = parseFloat(getAmountDue() || 0);
    if (amountDue <= 0) return amountDue.toFixed(3);

    return input &&
      !isNaN(input) &&
      /^\d+(\.\d{1,2})?$/.test(input) &&
      parseFloat(input) <= amountDue
      ? (parseFloat(input) - amountDue)?.toFixed(3)
      : "0";
  };

  const handleSubmit = async (type = "1") => {
    showLoader();
    try {
      const grandTotal = getTotal().total?.toFixed(3);
      let pendingAmount = Math.abs(parseFloat(getReminingValue())).toFixed(3);
      let paidAmount = parseFloat(grandTotal).toFixed(3);
      let purchase_type = "0";

      if (parseFloat(input) < grandTotal) {
        paidAmount = input;
        purchase_type = "2";
      } else {
        purchase_type = type;
      }

      if (type == "2") {
        paidAmount = 0;
        pendingAmount = parseFloat(grandTotal).toFixed(3);
      }

      const paydata = {
        orderID: unqui,
        // date: getFormattedCurrentDate2(),
        date: formData.invoice_date,
        amount: "0",
        total_amount: grandTotal,
        cash: 0,
        credit: 0,
        card: 0,
        type: 1,
        mop: "0",
        complete: "0",
      };

      if (type == "1") {
        if (pendingAmount > 0) {
          paydata.cash = paidAmount;
          paydata.credit = pendingAmount;
          paydata.card = 0;
          paydata.mop = "1,2";
          purchase_type = "2";
        } else {
          paydata.cash = paidAmount;
          paydata.credit = 0;
          paydata.card = 0;
          paydata.mop = "1";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "2") {
        paydata.cash = paidAmount;
        paydata.credit = pendingAmount;
        paydata.card = 0;
        paydata.mop = "2";
        purchase_type = "2";
      } else if (type == "4") {
        if (pendingAmount > 0) {
          paydata.cash = 0;
          paydata.credit = pendingAmount;
          paydata.card = paidAmount;
          paydata.mop = "2,4";
          purchase_type = "2";
        } else {
          paydata.cash = 0;
          paydata.credit = 0;
          paydata.card = paidAmount;
          paydata.mop = "4";
          purchase_type = "1";
          paydata.complete = "1";
        }
      } else if (type == "5") {
        purchase_type = "1";
        paydata.complete = "1";
        if (pendingAmount > 0) {
          paydata.cash = paidAmount;
          paydata.credit = 0;
          paydata.card = pendingAmount;
          paydata.mop = "1,4";
        } else {
          paydata.cash = paidAmount;
          paydata.credit = 0;
          paydata.card = 0;
          paydata.mop = "1";
        }
      }

      setPurchaseUnit(purchase_type);

      if (rows.length <= 0) {
        toast.error("Add item before updating purchase order");
        hideLoader();
        return;
      }

      if (!SupplierId) {
        toast.error("Required supplier");
        hideLoader();
        return;
      }

      const saveObject = {
        user_id: AuthUser?.user_id,
        supplier_id: SupplierId,
        data: JSON.stringify(rows),
        po_id: unqui,
        sub_total: getTotal().sub_total,
        lpo_no: formData.lpo_no,
        discount: discount,
        vat: vat,
        freight_charges: freightCharges,
        other_charges: otherCharges,
        previous_due: previousDue,
        total: getTotal().total,
        round_off: getTotal().roundOff,
        grand_total: getTotal().grandTotal,
        balance: pendingAmount,
        shop_id: shopItem?.shop_id || "0",
        created_by: UserItem?.user_id || "0",
        purchase_unit: purchase_type,
        sales_remaining: purchase_type == "2" ? grandTotal - paidamount : 0,
        amount: purchase_type == "2" ? 0 : paidAmount,
        update_check: isUpdate,
        date: formData.invoice_date,
      };

      const payload = new FormData();
      if (file) {
        payload.append("file", file);
      }

      Object.keys(saveObject).forEach((key) => {
        payload.append(key, saveObject[key]);
      });

      const response = await updatePurchaseCredit(payload);
      await onReqCreatePayment(paydata);
      hideLoader();

      if (response?.data.status === "success") {
        // General ledger transactions are automatically recorded by the backend service on update.

        toast.success("Purchase Order updated successfully");
        navigate(-1);
      }
    } catch (error) {
      hideLoader();
      if (error.response?.data?.errors) {
        error.response.data.errors.forEach((err, index) => {
          toast.error(`Error in row ${index + 1}: ${err.message}`);
        });
      } else {
        toast.error(
          error?.response?.data?.message || "Error updating order: Something went wrong"
        );
      }
    }
  };

  const closeModal = () => {
    setshowSupplierModal(false);
  };

  return (
    <div className="page-content">
      <div className="row">
        <div className="col-6 d-flex column-gap-3 align-items-center justify-content-between">
          <h3>{unqui || "Edit Purchase"}</h3>
        </div>
      </div>

      <NewCommonCardUi feilds={fields} />

      <div className="container-fluid mt-1 px-2">
        <div className="row">
          <div className="card col-10">
            <div className="card-body">
              <div className="d-flex justify-content-end"></div>
              <div className="table-responsive" style={{ minHeight: "500px" }}>
                <table
                  id="example"
                  className="table table-striped table-sm table-bordered"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      <th className="text-small">S.No</th>
                      <th className="text-small">Raw Material Name</th>
                      <th className="text-small">Item Code</th>
                      <th className="text-small">Qty</th>
                      <th className="text-small">Unit Price</th>
                      <th className="text-small">Total Amount</th>
                      <th className="text-small">Manufactured Date</th>
                      <th className="text-small">Expiry Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{row.product_name}</td>
                        <td>{row.item_code}</td>
                        <td>{row.qty}</td>
                        <td>
                          <input
                            type="number"
                            name="purchase_price"
                            min={1}
                            value={row.purchase_price}
                            className="w-100"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              handleUpdateProduct(index, value, name);
                            }}
                            style={{ textAlign: "center", minWidth: "100px" }}
                          />
                        </td>
                        <td>{row.total_amount}</td>
                        <td>
                          <input
                            type="date"
                            name="manufactured_date"
                            max={row.expiry_date}
                            value={row.manufactured_date}
                            className="w-100"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              handleUpdateProduct(index, value, name);
                            }}
                            style={{ textAlign: "center", minWidth: "100px" }}
                          />
                        </td>
                        <td>
                          <input
                            type="date"
                            name="expiry_date"
                            min={row.manufactured_date}
                            value={row.expiry_date}
                            className="w-100"
                            onChange={(e) => {
                              const { name, value } = e.target;
                              handleUpdateProduct(index, value, name);
                            }}
                            style={{ textAlign: "center", minWidth: "100px" }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-2 p-0 ps-1" style={{ height: "fit-content" }}>
            <div
              className="card py-2 border-black p-1"
              style={{ height: "fit-content" }}
            >
              {InputField(
                "Total",
                "Vat",
                "text",
                getTotal().sub_total.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}

              <div className={`form-group mb-1 d-flex align-items-end col-${12}`}>
                <div className="col-4">
                  <label className="col-12 text-verysmall">{"Discount"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={discount}
                      onChange={(e) => {
                        setDiscount(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>

                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    value={
                      ((rows.reduce(
                        (acc, item) => acc + (parseFloat(item.total_amount) || 0),
                        0
                      ) *
                        (discount ? parseFloat(discount) : 0)) /
                        100).toFixed(2)
                    }
                    disabled={true}
                  />
                </div>
              </div>

              <div className={`form-group mb-1 d-flex align-items-end col-${12}`}>
                <div className="col-4">
                  {/* <label className="col-12 text-verysmall">{"VAT"}</label> */}
                  <label className="col-12 text-verysmall">{"GST"}</label>
                  <div className="col-12">
                    <input
                      type={"text"}
                      value={vat}
                      onChange={(e) => {
                        setVat(e.target.value);
                      }}
                      className="text-verysmall col-9"
                      style={{ height: "1.5rem" }}
                      placeholder="00.0"
                    />
                    <label className="col-3 text-verysmall">%</label>
                  </div>
                </div>

                <div className="col-8">
                  <input
                    className="w-100 text-verysmall"
                    style={{ height: "1.5rem" }}
                    disabled={true}
                    value={
                      ((rows.reduce(
                        (acc, item) => acc + (parseFloat(item.total_amount) || 0),
                        0
                      ) *
                        (vat ? parseFloat(vat) : 0)) /
                        100).toFixed(2)
                    }
                  />
                </div>
              </div>

              {InputField(
                "Freight Charges",
                "freight_charges",
                "number",
                freightCharges,
                (e) => {
                  setFreightCharges(e.target.value);
                }
              )}
              {InputField(
                "Other Charges",
                "other_charges",
                "number",
                otherCharges,
                (e) => {
                  setOtherCharges(e.target.value);
                }
              )}
              {InputField(
                "Grand Total",
                "Vat",
                "text",
                getTotal().grandTotal.toFixed(2),
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Paid amount",
                "paid",
                "text",
                paidamount,
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
              {InputField(
                "Balance",
                "Vat",
                "text",
                SupplierBalance?.toFixed(2) || "0.00",
                () => { },
                "",
                12,
                0,
                "",
                undefined,
                true
              )}
            </div>
          </div>
        </div>

        {showSupplierModal && (
          <SupplierForm
            onClose={() => closeModal()}
            fetchSuppliers={fetchSuppliers}
          />
        )}

        <div
          className="fixed-bottom bg-white d-flex justify-content-center py-2 column-gap-3"
          style={{ height: "50px" }}
        >
          <button
            className="btn-primary btn py-0 text-small"
            disabled={rows.length == 0}
            onClick={() => {
              if (!SupplierId) {
                toast.error("Required supplier");
                return;
              } else {
                setShowPayModal(true);
              }
            }}
          >
            Update
          </button>
        </div>

        <div
          className="modal fade show"
          style={{ display: PO ? "block" : "none" }}
          tabIndex="-1"
          role="dialog"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header border-0">
                <h5 className="modal-title">
                  {<span className="text-danger">Select Purchase Order</span>}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={() => setPO(false)}
                ></button>
              </div>
              <div className="modal-body p-0">
                <table className="min-w-full m-2 border border-gray-300">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border px-2 py-2">Order No</th>
                      <th className="border px-2 py-2">Supplier Name</th>
                      <th className="border px-2 py-2">Date</th>
                      <th className="border px-2 py-2">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.isArray(PurchaseOrder) && PurchaseOrder.length > 0 ? (
                      PurchaseOrder.map((item) => (
                        <tr key={item.id} className="border">
                          <td className="border px-2 py-2">{item?.po}</td>
                          <td className="border px-2 py-2">{item?.supplier_name}</td>
                          <td className="border px-2 py-2">{item?.date}</td>
                          <td className="border px-2 py-2">
                            <button
                              onClick={() => {
                                setIsUpdate("0");
                                GetPurchaseData(item);
                              }}
                              className="bg-primary text-white px-3 py-1 rounded hover:bg-blue-600"
                            >
                              Select
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="4" className="text-center p-4">
                          No purchase orders available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="mt-5">
                  <button
                    type="button"
                    className="btn btn-secondary me-2 float-end"
                    onClick={() => setPO(false)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <PaymentModal
          show={showPayModal}
          onClose={() => setShowPayModal(false)}
          onSelectPayment={handlePaymentType}
        />

        <CashModal
          show={cashShow}
          onClose={() => setCashShow(false)}
          input={input}
          getAmountDue={getAmountDue}
          getReturnValue={getReturnValue}
          getReminingValue={getReminingValue}
          handleClick={handleClick}
          handleBackspace={handleBackspace}
          handleSubmit={handleSubmit}
          paidAmount={paidamount}
        />

        <CashCardModal
          show={cashCardShow}
          onClose={() => setCashCardShow(false)}
          input={input}
          getAmountDue={getAmountDue}
          getReturnValue={getReturnValue}
          getReminingValue={getReminingValue}
          handleClick={handleClick}
          handleBackspace={handleBackspace}
          handleSubmit={handleSubmit}
        />

        <CardModal
          show={cardShow}
          onClose={() => setCardShow(false)}
          input={input}
          setInput={setInput}
          getAmountDue={getAmountDue}
          getReturnValue={getReturnValue}
          getReminingValue={getReminingValue}
          handleClick={handleClick}
          handleBackspace={handleBackspace}
          handleSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default EditPurchase;
